//トップページ　キービジュアルスライダー
export function idxFunc() {
  let indexTop = $('#indexTop').length;

  if(indexTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

    wait(0)
      .then(() => {
        $('#mainviewImg').addClass('isShow');
        return wait(600)
      })
      .then(() => {
        $('#mainviewTit').addClass('isShow');
        return wait(600)
      })
  }
}